import React, { useState } from 'react';

function Skills() {
	const [stack, toggleStack] = useState<'client' | 'server'>('client');
	interface Skill {
		level: number;
		name: string;
		stack: 'frontend' | 'backend';
	}
	const skills: Skill[] = [
		{ level: 80, name: "Node JS, Express JS", stack: "backend" },

		{ level: 70, name: "Golang, Gin", stack: "backend" },
		{ level: 90, name: "Python, Flask", stack: "backend" },
		{ level: 85, name: "SQL, PostgeSQL, MySQL, MongoDB", stack: "backend" },
		{ level: 87, name: "Git, Docker, AWS", stack: "backend" },
		{ level: 89, name: "HTML5, CSS3", stack: "frontend" },
		{ level: 92, name: "Bootstrap, Tailwind CSS", stack: "frontend" },
		{ level: 85, name: "Javascript, Reactjs, Nextjs", stack: "frontend" },
		{ level: 90, name: "React Native", stack: "frontend" },
	];

	return (
		<section className="flex flex-col w-full px-4 sm:px-12 md:px-16 max-w-7xl mx-auto text-slate-500">
			<div className="bg-white rounded-sm pb-8">
				<div className="flex items-center gap-5 mb-5">
					<button
						onClick={() => toggleStack('client')}
						className={
							stack === 'client'
								? 'flex-1 py-3'
								: 'flex-1 py-3 bg-app'
						}
					>
						Frontend
					</button>
					<button
						className={
							stack === 'server'
								? 'flex-1 py-3 rounded-sm'
								: 'flex-1 py-3 bg-app'
						}
						onClick={() => toggleStack('server')}
					>
						Backend
					</button>
				</div>
				{stack === 'client' ? (
					<section>
						<header className="pt-5 px-4 sm:text-center">
							<h1 className="text-primary text-xl font-semibold">
								Frontend Skills
							</h1>
							<p className="py-4 max-w-md mx-auto font-light line-clamp-4">
								I used these tools on daily basis to build
								highly responsive, customization user interfaces
								for mobile and web applications
							</p>
						</header>
						<div className="flex-1 flex flex-col justify-center gap-8 py-5 md:py-10 px-4 sm:px-8">
							{skills
								.filter((skill) => skill.stack === 'frontend')
								.map((skill, key) => (
									<Skill {...skill} key={key} />
								))}
						</div>
					</section>
				) : (
					<section>
						<header className="pt-5 px-4 sm:text-center">
							<h1 className="sm:text-center text-primary text-xl font-semibold">
								Backend Skills
							</h1>
							<p className="py-4 max-w-md mx-auto font-light line-clamp-4">
								A list of backend tools I used on daily basis to
								build and deploy dockerized RestFul API's used
								by frontend developers.
							</p>
						</header>
						<div className="flex-1 flex flex-col justify-center gap-8 py-5 md:py-10 px-8">
							{skills
								.filter((skill) => skill.stack === 'backend')
								.map((skill, key) => (
									<Skill {...skill} key={key} />
								))}
						</div>
					</section>
				)}
			</div>
		</section>
	);
}

export default Skills;

const Skill = ({ name, level }: { name: string; level: number }) => {
	return (
		<div className="w-full bg-slate-300 rounded-sm overflow-hidden">
			<div
				style={{ width: `${level}%` }}
				className="bg-[#35486b] py-1 text-sm sm:text-base px-4 md:px-8 min-w-fit"
			>
				<h1 className="font-medium text-slate-100">{name}</h1>
			</div>
		</div>
	);
};
